import { GetterTree } from 'vuex';
import { DeviceState, Device } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<DeviceState, RootState> = {
  sortedDevices(state): Device[] {
    let devices = state.devices;
    const search = state.search.toLowerCase();

    if (search) {
      devices = devices.filter((device: any) => {
        return Object.keys(device).some((key) => {
          return (
            String(device[key])
              .toLowerCase()
              .indexOf(search) > -1
          );
        });
      });
    }

    return (devices || []).sort((a, b) => {
      if (a.sigfoxSerial < b.sigfoxSerial) {
        return -1;
      } else if (a.sigfoxSerial > b.sigfoxSerial) {
        return 1;
      }
      return 0;
    });
  },
};
